import Game from "./Game";

export default class ContainmentRect extends Phaser.Geom.Rectangle {
  index: number;

  constructor(scaleFactor = 1, explicitWidth = 0, explicitHeight = 0) {
    super(0, 0, 0, 0);
    this.index = 1;
    this.width =
      explicitWidth > 0
        ? explicitWidth
        : Game.Core.scene.renderer.width * scaleFactor;
    this.height =
      explicitHeight > 0
        ? explicitHeight
        : Game.Core.scene.renderer.height * scaleFactor;
  }

  DespawnIfOutside(objectsArray) {
    const currentObject = objectsArray[this.index % objectsArray.length];
    this.index++;

    if (!currentObject) return false;
    if (!currentObject.isCullable && !currentObject.isTeleportOnCull)
      return false;

    // Double-check: Never despawn bosses even if they're marked as cullable
    if (currentObject.isBoss) {
      return false;
    }

    const xDistance = Math.abs(Game.Core.Player.x - currentObject.x);
    const yDistance = Math.abs(Game.Core.Player.y - currentObject.y);

    if (!this.contains(xDistance, yDistance)) {
      if (currentObject.isTeleportOnCull) {
        currentObject.OnTeleportOnCull();
        return false;
      }
      currentObject.DeSpawn();
    }
    return true;
  }
  Contains(gameObject) {
    const xDistance = Math.abs(Game.Core.Player.x - gameObject.x);
    const yDistance = Math.abs(Game.Core.Player.y - gameObject.y);
    return this.contains(xDistance, yDistance);
  }
}
